﻿import { defineComponent, PropType } from 'vue';
import axios from 'axios';

import { passenger } from "../../../objects/v1_2/Booking/Passenger";

import { country } from "../../../objects/v1_3/web_engine/country";
import { country_nationality } from '../../../objects/v1_3/web_engine/country_nationality';

import { Booking } from "../../../services/booking";
import { Web_Engine } from "../../../services/web_engine";
import { time } from 'vue-gtag';
import Passenger from '../passenger.vue';

const Book = new Booking();
const Web = new Web_Engine();

const capitalise = {
    updated: (el: any, binding: any) => {
        el.value = el.value.toLowerCase().replace(/^.|\s\S/g, function (a) { return a.toUpperCase(); });
    }
}


export default defineComponent({
    name: "passenger",
    props: {
        index: Number,
        passenger: Object as PropType<passenger>,
        checkPassengers: Boolean

    },
    directives: {
        capitalise
    },
    data() {
        return {
            isOpen: true,
            countries: [] as country_nationality[],
            saving_passenger: false as Boolean,
            has_saved_details: false as Boolean,
            first_email: null as string | null,
            confirm_email: null as string | null,
            date_of_birth: null as string | null,
            countryName: null as string | null | undefined,
            newsletterCheckbox: false as Boolean,
            dialCodeLead: null as string | null,
            dialNumberLead: null as string | null,
            dialCodeEmerg: null as string | null,
            dialNumberEmerg: null as string | null,
            gender: null as string | null,
            istyping: false as Boolean,
            alreadyChecked: false as Boolean,
            dob_day: '' as string,
            dob_month: '' as string,
            dob_year: null as string | null,
        }
    },
    watch: {
        checkPassengers: {
            handler(newVal: boolean) {
                if (newVal === true) {
                    this.Update_Details(null);
                    this.alreadyChecked = true;
                    
                }
            },
            immediate: true 
        }
        },
        computed: {
            dobValidationState(): 
                | 'not_required'
                | 'required'
                | 'invalid_date'
                | 'child_too_young'
                | 'child_too_old'
                | 'adult_too_young'
                | 'valid' {
        
                if (this.isAAT()) return 'not_required';
        
                const required = this.isDoBRequired();
                const date = this.assembleDob();
        
                // No date entered
                if (!date) return required ? 'required' : 'not_required';
        
                const parts = date.split('-');
                const day   = parseInt(parts[0] ?? '0');
                const month = parseInt(parts[1] ?? '0');
                const year  = parseInt(parts[2] ?? '0');
        
                if (!day || !month || !year || year < 1900 || year > new Date().getFullYear()
                    || day < 1 || day > 31 || month < 1 || month > 12) {
                    return 'invalid_date';
                }
        
                const dob = new Date(year, month - 1, day);
        
                if (this.isChild()) {
                    const earliest = this.getEarliestDepartureDate();
                    const latest   = this.getLatestDepartureDate();
        
                    if (this.calculateAge(dob, earliest) < 5)  return 'child_too_young';
                    if (this.calculateAge(dob, latest)   > 16) return 'child_too_old';
                } else {
                    const earliest = this.getEarliestDepartureDate();
                    if (this.calculateAge(dob, earliest) < 17) return 'adult_too_young';
                }
        
                return 'valid';
            },
        
            DoBValid(): boolean {
                return this.dobValidationState !== 'invalid_date';
            },
            childAgeValid(): boolean {
                return !['child_too_young', 'child_too_old'].includes(this.dobValidationState);
            },
            adultAgeValid(): boolean {
                return this.dobValidationState !== 'adult_too_young';
            },
        },
        methods: {
        async Update_Details(e: any) {
            this.setCountry();
            this.setGender();
            this.setEmail();
            this.date_of_birth = this.assembleDob();
            this.passenger.date_of_birth = this.date_of_birth;

            if(!this.isAgent_Login()){
                this.passenger.telephone_number = this.combineDialCode(this.dialCodeLead, this.dialNumberLead);
                this.passenger.emergency_number = this.combineDialCode(this.dialCodeEmerg, this.dialNumberEmerg);
            }


            let checkspassed : boolean = true;

            checkspassed = this.Valid_Form(this.passenger ?? new passenger(), this.$store.getters.get_Booking.passengers);

            const dobPasses = this.dobValidationState === 'valid' || this.dobValidationState === 'not_required';
            checkspassed = dobPasses && checkspassed;

            if (this.passenger.required_fields.includes("email")) {
                checkspassed = this.passenger.email == this.confirm_email && checkspassed;
            }

            console.log(`[PAX ${this.index}] checkspassed=${checkspassed} | dobState=${this.dobValidationState} | dob=${this.passenger.date_of_birth}`);

            if (checkspassed) {
                await this.ValidPassengerFound(e);
            } else {
                this.$store.commit("Set_isValidPassengers", { isValidPassengers: false });
            }
        },
        async ValidPassengerFound(e: any){
            this.saving_passenger = true;

            if(this.newsletterCheckbox && !this.isAgent_Login()) {
                this.postFloDesk();
            }

            await Book.Update_Booking_Passengers(this.$store.getters.get_Booking, this.$store.getters.get_Agent_Login, this.$store.getters.get_Currency).then(response => { return response.json(); });
            this.$store.commit("Setup_Booking", { Booking_Details: await Book.Get_Book(this.$store.getters.get_Booking.group_booking_id, this.$store.getters.get_Agent_Login) });
            this.saving_passenger = false;
            this.has_saved_details = true;
            this.isOpen = false;

            let allPaxValid : boolean = this.AllPassengers_Details_Collected();
            if (allPaxValid == true && this.$store.getters.get_isValidPassengers !== false) {
                this.$store.commit("Set_isValidPassengers", { isValidPassengers: true });
            }

            if (this.$store.getters.get_Booking.passengers.length <= (this.index ?? 0) + 1) {
                this.$router.push({ hash: "#payment_checkout" });
            } 
            // else {
            //     this.$router.push({ hash: "#passenger_" + this.$store.getters.get_Booking.passengers[(this.index ?? 0) + 1].passenger_identifier });
            // }

            if (e !== undefined && e !== null) {
                 e.preventDefault();
            }
        },
        setEmail() {
            if (this.passenger.required_fields.includes("email")) {
                if (this.first_email == this.confirm_email) {
                    this.passenger.email = this.first_email;
                } else {
                    this.passenger.email = null;
                }
            } 
            else
            {
                this.passenger.email = this.first_email;
            }
        },
        combineDialCode(dialCode: string | null, dialNumber: string | null): string {
            let fullNumber = "";

            if(dialNumber == null || dialNumber == '') {
                return fullNumber;
            }

            if (!dialCode && !dialNumber) {
                return fullNumber;
            }

            if (dialNumber) {
                if (dialNumber.startsWith("0")) {
                    dialNumber = dialNumber.substring(1);
                }
                dialNumber = dialNumber.replace(/[\s.-]/g, '');
            }


            fullNumber = (dialCode ?? "") + (dialNumber ?? "");


            return fullNumber;
        },        
        Valid_Form(Passenger: passenger, Booking_Passengers: passenger[]): boolean {
            let Return_Value: boolean = true;

            Booking_Passengers.forEach((booking_passenger: passenger) => {

                booking_passenger.first_name = this.String_Char_limit(booking_passenger.first_name ?? "", 30);
                booking_passenger.family_name = this.String_Char_limit(booking_passenger.family_name ?? "", 30);
                booking_passenger.emergency_contact = this.String_Char_limit(booking_passenger.emergency_contact ?? "", 30);


                if (Passenger.passenger_identifier == booking_passenger.passenger_identifier) {

                    Return_Value = this.Check_Field(Return_Value, "first_name", booking_passenger.first_name);
                    Return_Value = this.Check_Field(Return_Value, "family_name", booking_passenger.family_name);
                    Return_Value = this.Check_Field(Return_Value, "email", booking_passenger.email);
                    Return_Value = this.Check_Field(Return_Value, "iso_nationality", booking_passenger.iso_nationality);
                    Return_Value = this.Check_Field(Return_Value, "date_of_birth", booking_passenger.date_of_birth);
                    Return_Value = this.Check_Field(Return_Value, "telephone_number", booking_passenger.telephone_number);
                    Return_Value = this.Check_Field(Return_Value, "emergency_contact", booking_passenger.emergency_contact);
                    Return_Value = this.Check_Field(Return_Value, "emergency_number", booking_passenger.emergency_number);
                    Return_Value = this.Check_Field(Return_Value, "gender", booking_passenger.gender);
                }
            });

            return Return_Value;
        },
        redWarning(field: string, field_value): boolean {
            if(this.alreadyChecked == false) {
                return false;
            }
            if(this.require_field(field) == false)
            {
                return false
            }


            if(this.Check_Field(true, field, field_value))
            {
                return false;
            }
            else
            {
                return true;
            }
        },
        isHAG(): boolean {
            if (import.meta.env.VITE_DEFAULT_CLASS == "HAG") {
                return true;
            }
            return false;
        },
        Check_Field(Return_Value: boolean, field_name: string, field_value: string | null): boolean {
            if (this.require_field(field_name) == true) {
                if (field_value == null || field_value.trim() + "" == "" || Return_Value == null) {
                    Return_Value = false;
                }
            }

            return Return_Value;
        },
        String_Char_limit(value: string, limit: number): string {
            if (value.length > limit) {
                value = value.substring(0, limit);
            }

            return value;
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        async Get_Country() {
            this.countries = (await Web.Get_Countries()).countries;
        },
        Passenger_Details_Collected(): boolean {
            let result : boolean = false;
            if (this.has_saved_details) {
                result = Book.Valid_Passenger_Complete(this.passenger?.passenger_identifier ?? "", this.$store.getters.get_Booking_Un_Edited);
            }
            return result;
        },
        AllPassengers_Details_Collected(): boolean {
            return Book.Valid_AllPassengers_Complete(this.$store.getters.get_Booking_Un_Edited);
        },
        hide_field(Field: string): boolean {
            let Field_Hide: boolean = true;
            this?.passenger?.required_fields.forEach(function (Input_Field: string) {
                if (Input_Field == Field) {
                    Field_Hide = false;
                }
            });

            this?.passenger?.optional_fields.forEach(function (Input_Field: string) {
                if (Input_Field == Field) {
                    Field_Hide = false;
                }
            });

            return Field_Hide;
        },
        require_field(Field: string): boolean {
            let Require_Field: boolean = false;
            this?.passenger?.required_fields.forEach(function (Input_Field: string) {
                if (Input_Field == Field) {
                    Require_Field = true;
                }
            });

            return Require_Field;
        },
        isMobile(): boolean{
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        },
        isChild(): boolean {
            return this.passenger?.age_category?.toLowerCase() === 'child';
        },
        isDoBRequired(): boolean {
            if (this.isAAT()) return false;
            return this.require_field('date_of_birth') || this.isChild();
        },
        showDoBField(): boolean {
            if (this.isAAT()) return false;
            return !this.hide_field('date_of_birth') || this.isChild();
        },
        assembleDob(): string | null {
            if (this.dob_day && this.dob_month && this.dob_year && this.dob_year.length === 4) {
                return `${this.dob_day}-${this.dob_month}-${this.dob_year}`;
            }
            return null;
        },
        
        formatDOB() {

            let dob = this.date_of_birth?.toString().replaceAll('-', '')

            switch (dob?.length) {
                case undefined:
                case 0:
                case 1:
                case 2:
                    break;
                case 3:
                    dob = dob?.substring(0, 2) + "-" + dob?.substring(2, 3);
                    break;
                case 4:
                    dob = dob?.substring(0, 2) + "-" + dob?.substring(2, 4);
                    break;
                case 5:
                case 6:
                case 7:
                case 8:
                    dob = dob?.substring(0, 2) + "-" + dob?.substring(2, 4) + "-" + dob?.substring(4, dob?.length);
                    break;
                default:
                    dob = dob?.substring(0, 2) + "-" + dob?.substring(2, 4) + "-" + dob?.substring(4,8);
                    break;

            }
            return dob;

        },
        setGender() {
            if (this.gender == null || this.gender === '') return;

            if (this.passenger) {
                this.passenger.gender = this.gender;
            }
        },
        setCountry() {
            if (this.countryName == null) return;

            this.countries.forEach(country => {
                if(country.country.trim() == this.countryName.trim()){
                    if(country.iso_country_code != null){
                        this.passenger.iso_nationality = country.iso_country_code;
                    }
                }
            });
        },
        getFloDeskAPI(): string {
            return String(import.meta.env.VITE_FLODESK_API);
        },
        getFloDeskKEY(): string {
            return String(import.meta.env.VITE_FLODESK_KEY);
        },
        getFloDeskSegment(): string {
            return String(import.meta.env.VITE_FLODESK_SEGMENT);
        },
        getAppName(): string {
            return String(import.meta.env.VITE_GA_APP_NAME);
        },
        getIsDebug(): boolean {
            return Boolean(import.meta.env.VITE_DEFAULT_IS_DEBUG);
        },
        selectElement(id, valueToSelect) {    
            let element = document.getElementById(id);
            if (element) {
                (element as HTMLInputElement).value = valueToSelect;
            }
        },        
        autofill(autofillCalled) {
            const testNames = [
                { firstName: "John", lastName: "Doe" },
                { firstName: "Jane", lastName: "Smith" },
                { firstName: "Alice", lastName: "Johnson" },
                { firstName: "Bob", lastName: "Brown" },
                { firstName: "Charlie", lastName: "Davis" },
                { firstName: "Emily", lastName: "Wilson" },
                { firstName: "Frank", lastName: "Taylor" },
                { firstName: "Grace", lastName: "Anderson" },
                { firstName: "Henry", lastName: "Thomas" },
                { firstName: "Ivy", lastName: "Moore" }
            ];
            if (typeof this.index === 'number' && this.index >= 0 && this.index < testNames.length) {
                this.passenger.first_name = testNames[this.index].firstName;
            } else {
                console.error("Invalid index for testNames array");
            }
            if (typeof this.index === 'number' && this.index >= 0 && this.index < testNames.length) {
                this.passenger.family_name = testNames[this.index].lastName;
            } else {
                console.error("Invalid index for testNames array");
            }
            this.passenger.telephone_number = "0123456789";
            this.dob_day = '01';
            this.dob_month = '01';
            this.dob_year = '1970';
            this.first_email = "Test@TTC.com";
            this.confirm_email = "Test@TTC.com";
            this.countryName = "United Kingdom";
            this.passenger.emergency_contact = "Test";
            this.passenger.emergency_number = "0123456789";
            this.gender = "Male";
            this.dialCodeLead = '44';
            this.dialNumberLead = '123456789';
            this.dialCodeEmerg = '1';
            this.dialNumberEmerg = '987654321';

            this.selectElement('dialCode', '44');
            this.selectElement('telephone', '123456789');
            this.selectElement('emerdialCode', '1');
            this.selectElement('emergency_number', '987654321');
            

            // Call itself again after a second, but only once
            if (!autofillCalled) {
            autofillCalled = true;
            setTimeout(() => {
                this.autofill(autofillCalled);
            }, 5);
            }
        },
        getDialingCodes(countries: country_nationality[]): country_nationality[] {
            var ValidCountries = [] as country_nationality[];

            countries.forEach(country => {
                if(country.dialing_code != null && country.country != null && country.dialing_code.toLowerCase() != "null" && country.country.toLowerCase() != "null"){
                    ValidCountries.push(country);
                }
            });

            return ValidCountries;
        },
        isLeadPax() : boolean {
            return this.index == 0;
        },
        setNullNames() {
            if(!this.isAgent_Login()) { // && this.isLeadPax()) {
                if (this.require_field("first_name")){
                    this.passenger.first_name = "";
                }
                if(!this.isAgent_Login() && this.require_field("family_name")){
                    this.passenger.family_name = "";
                }
            }
        },
        
        async postFloDesk() {

            axios.post(this.getFloDeskAPI(), {
                email: this.$store.getters.get_Booking.passengers[0].email,
                first_name: this.$store.getters.get_Booking.passengers[0].first_name,
                last_name: this.$store.getters.get_Booking.passengers[0].family_name,
            },
            {
                headers: {"User-Agent": this.getAppName(),"Authorization": "Basic " + this.getFloDeskKEY()}
            })
            .then((res) => {
                //console.log(res.data)

                axios.post('https://api.flodesk.com/v1/subscribers/'+this.$store.getters.get_Booking.passengers[0].email+'/segments', {

                id_or_email: this.$store.getters.get_Booking.passengers[0].email,
                segment_ids: [this.getFloDeskSegment()]

                },
                {
                    headers: {"User-Agent": this.getAppName(),"Authorization": "Basic "+ this.getFloDeskKEY()}
                })
                .then((res) => {console.log(res.data)})
                .catch((error) => {console.error(error)})
            })
            .catch((error) => {console.error(error)})
        },
        isPaymentLink(): boolean {
            return window.location.href.toLowerCase().includes('paylink');
        },

        getEarliestDepartureDate(): Date {
            const trips = this.$store.getters.get_Booking?.trips as any[] | undefined;
            if (!trips?.length) return new Date();
            return trips.reduce((earliest: Date, trip: any) => {
                if (!trip.departure_date) return earliest;
                const d = new Date(trip.departure_date);
                return d < earliest ? d : earliest;
            }, new Date(trips[0].departure_date ?? Date.now()));
        },
        

        getLatestDepartureDate(): Date {
            const trips = this.$store.getters.get_Booking?.trips as any[] | undefined;
            if (!trips?.length) return new Date();
            return trips.reduce((latest: Date, trip: any) => {
                if (!trip.departure_date) return latest;
                const d = new Date(trip.departure_date);
                return d > latest ? d : latest;
            }, new Date(trips[0].departure_date ?? Date.now()));
        },
        

        calculateAge(dob: Date, referenceDate: Date): number {
            let age = referenceDate.getFullYear() - dob.getFullYear();
            const m = referenceDate.getMonth() - dob.getMonth();
            if (m < 0 || (m === 0 && referenceDate.getDate() < dob.getDate())) age--;
            return age;
        },

        isValidDoB(_dateString: string | null | undefined): boolean {
            return this.dobValidationState !== 'invalid_date' 
                && this.dobValidationState !== 'required';
        },

        
    },
    mounted() {
        this.setNullNames();
        this.Get_Country();
    }
})